import { render, staticRenderFns } from "./ProductSuperiority.vue?vue&type=template&id=fb25be82&"
import script from "./ProductSuperiority.vue?vue&type=script&lang=js&"
export * from "./ProductSuperiority.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports